module.exports = __webpack_public_path__ + "media/facial-recognition/bg-circle-a16adcf1.svg";